import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';

import FeedbackModalWrapper from './components/FeedbackModalWrapper';

import { submitFeedback } from './ducks';

import { Gap, Checkbox, Phone, FormLabel as Label } from '~ui-kit';

import { primaryColor } from '~theme';

import headerIcon from '~images/trouble_report.svg';

const TroubleReportModal = props => {
  const [message, setMessage] = useState('');
  const [isUrgent, setIsUrgent] = useState(false);
  const [contactSender, setContactSender] = useState(false);
  const [contactPhone, setContactPhone] = useState('');

  const dispatch = useDispatch();

  const show = useSelector(state => state.modals.show);
  const orderId = useSelector(state => state.modals.orderId);
  const title = useSelector(state => state.modals.title);
  const content = useSelector(state => state.modals.content);

  useEffect(() => {
    // Reset state when hidden
    if (!show) {
      setMessage('');
      setIsUrgent(false);
      setContactSender(false);
      setContactPhone('');
    }
  }, [show]);

  const handleSubmit = () => {
    dispatch(
      submitFeedback({
        message,
        type: 'MESSAGE_TROUBLE_REPORT',
        orderId,
        isUrgent,
        contactSender,
        contactPhone,
      })
    );
  };

  const defaultTitle = `Ilmoita ongelmasta${
    orderId ? `: tilaus #${orderId || ''}` : ''
  }`;

  return (
    <FeedbackModalWrapper
      name="TROUBLE_REPORT"
      title={title || defaultTitle}
      confirmOnClick={handleSubmit}
      confirmDisabled={!message || (contactSender && !contactPhone)}
      headerLargeIcon={headerIcon}
    >
      <Wrapper>
        <OrderDetails>
          {content || 'Palvelukoordinaattorimme reagoi viestiisi pikimmiten.'}
        </OrderDetails>
        <br />
        <br />

        <Label required>Kommenttisi</Label>
        <TextArea
          className="form-control"
          maxLength="2000"
          rows={5}
          placeholder="Kuvaa ongelma mahdollisimman yksityiskohtaisesti"
          value={message}
          onChange={event => setMessage(event.target.value)}
        />

        <Gap height="24px" />

        <Checkbox
          label="Vaatii välitöntä reagointia"
          value={isUrgent}
          onChange={setIsUrgent}
        />
        <Gap height="24px" />

        <Checkbox
          label="Haluan, että minuun ollaan yhteydessä"
          value={contactSender}
          onChange={setContactSender}
        >
          {contactSender && (
            <>
              <Label required>Puhelinnumero</Label>
              <Phone
                placeholder="esim. 040..."
                name="contactPhone"
                value={contactPhone}
                onChange={event => setContactPhone(event.target.value)}
              />
            </>
          )}
        </Checkbox>

        <Gap height="50px" />
      </Wrapper>
    </FeedbackModalWrapper>
  );
};

const Wrapper = styled.div`
  color: ${primaryColor};
`;

const OrderDetails = styled.p`
  font-size: 16px;
`;

const TextArea = styled.textarea`
  display: block;
  resize: none;
`;

export default TroubleReportModal;
